// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { GetPickupWarehousesApiParameter } from "@store/Framework/Services/StoreWarehouseService";
import { PickupWarehousesState } from "@store/Framework/Store/Store/Data/PickupWarehouses/PickupWarehousesState";
import { StoreWarehouseCollectionModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: PickupWarehousesState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const actions = {
    "Store/Data/PickupWarehouses/BeginLoadPickupWarehouses": (
        draft: Draft<PickupWarehousesState>,
        action: { parameter: GetPickupWarehousesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Store/Data/PickupWarehouses/CompleteLoadPickupWarehouses": (
        draft: Draft<PickupWarehousesState>,
        action: { parameter: GetPickupWarehousesApiParameter; collection: StoreWarehouseCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection.pickupWarehouses!);
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StorePickupWarehouseActions = Parameters<typeof reducer>[1];
export default reducer;
